@if (variant === 'toolbar') {
  <form
    class="search-toolbar"
    [formGroup]="searchForm"
    (ngSubmit)="onSearch()"
    novalidate
  >
    <mat-icon class="search-toolbar__lead-icon" aria-hidden="true">search</mat-icon>
    <input
      class="search-toolbar__input"
      type="search"
      placeholder="Filter references…"
      formControlName="referenceText"
      autocomplete="off"
      enterkeyhint="search"
      aria-label="Filter references"
    />
    @if (hasSearchText()) {
      <button
        type="button"
        mat-icon-button
        class="search-toolbar__clear"
        (click)="onReset()"
        aria-label="Clear search"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </form>
} @else {
  <div
    class="gingr-input-wrapper gingr-input-wrapper--with-form search-wrapper search-wrapper--legacy"
    [class.search-wrapper--full]="fullWidth"
  >
    <form [formGroup]="searchForm" (ngSubmit)="onSearch()">
      <input
        class="gingr-input--primary search-wrapper__input"
        matInput
        placeholder="Search references"
        formControlName="referenceText"
        autocomplete="off"
      />
    </form>
    <div class="search-buttons" aria-hidden="false">
      <button type="button" mat-icon-button (click)="onReset()" aria-label="Clear search">
        <mat-icon>close</mat-icon>
      </button>
      <button type="submit" mat-icon-button (click)="onSearch()" aria-label="Search">
        <mat-icon>search</mat-icon>
      </button>
    </div>
  </div>
}
